export const reducer = (state, { action, payload }) => {
	switch (action) {
		case 'OPEN_DRAWER':
			return { ...state, ...payload }
		case 'CLEAR_DRAWER':
			return { type: null, data: null }
		default:
			return state
	}
}
